import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=2c5d8458&scoped=true&lang=pug&"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts&"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=2c5d8458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d8458",
  null
  
)

export default component.exports